export default __webpack_public_path__ + "static/media/jointImage.b2b7a48b.png";